<div class="container-fluid" *ngIf="item">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Brands Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item"><a routerLink="/ecomm/brands">Brands</a></li>
            <li class="breadcrumb-item active">{{ isEditMode ? 'Edit' : 'View' }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{ isEditMode ? 'Edit Brand' : 'Brand Details' }}</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/brands" class="btn btn-light me-2">Back to List</a>
            <ng-container *ngIf="!isEditMode">
              <button type="button" class="btn btn-primary" (click)="startEdit()">Edit</button>
            </ng-container>
            <ng-container *ngIf="isEditMode">
              <button type="button" class="btn btn-light me-2" (click)="cancelEdit()">Back</button>
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </ng-container>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4" *ngIf="!isEditMode">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">ID</label>
              <input type="text" class="form-control" [value]="item.id" readonly>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" [value]="item.name" readonly>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">SAP Brand ID</label>
              <input type="text" class="form-control" [value]="item.sap_brand_id ?? '-'" readonly>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Status</label>
              <input type="text" class="form-control" [value]="statusLabel(item.status)" readonly>
            </div>
          </div>

          <div class="row gy-4" *ngIf="isEditMode">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">ID</label>
              <input type="text" class="form-control" [value]="item.id" readonly>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" name="name" [(ngModel)]="form.name"
                     [ngClass]="{'is-invalid': !form.name && validationTriggered, 'is-valid': validationTriggered && form.name}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">SAP Brand ID</label>
              <input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control" name="sap_brand_id"
                     [(ngModel)]="form.sap_brand_id" placeholder="Numbers only"
                     (input)="onSapBrandIdInput($event)">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Status <span class="text-danger">*</span></label>
              <select class="form-select" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
